<template>
  <div>
    <!-- Loading Screen -->
    <div class="center" v-if="showLoading">
      <lottie :options="defaultOptionsSplashScreen" :height="300" :width="300" v-on:animCreated="handleAnimationSplashScreen"/>
    </div>

    <!-- Main Content -->
    <div v-else class="page-container">
      <headerSection></headerSection>

      <!-- Hero Section -->
      <div class="hero-section">
        <div class="floating-ball ball-1"></div>
        <div class="floating-ball ball-2"></div>
        <div class="floating-ball ball-3"></div>

        <div class="container">
          <div class="hero-content">
            <div class="hero-icon-wrapper">
              <span class="hero-icon">🎲</span>
            </div>
            <h1 class="title-glow">{{ $t('huay_page.title') }}</h1>
            <div class="quota-display">
              <span class="quota-label">สิทธิ์ในการแทง:</span>
              <span class="quota-value">{{ countQTY }}/{{ QTY }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="container lottery-content">
        <!-- Info Card -->
        <div class="info-card">
          <div class="info-icon">ℹ️</div>
          <div class="info-text">{{ $t('huay_page.title2') }}</div>
        </div>

        <!-- Confirm Button (Top) -->
        <div class="confirm-section" v-if="isShow">
          <button
            type="button"
            @click="confirm()"
            :disabled="isDisabled"
            :class="['confirm-btn', { 'confirm-btn-disabled': isDisabled }]"
          >
            {{ buttonLabel }}
          </button>
        </div>

        <!-- Number Picker Grid -->
        <div class="numbers-grid">
          <div class="number-row" v-for="index in rows" :key="index">
            <a
              href="#"
              v-for="col in 5"
              :key="col"
              :class="['number-btn', { 'active': huays[renderNumber(index, col - 1)] }]"
              @click.prevent="selectNumber(renderNumber(index, col - 1))"
            >
              {{ renderNumber(index, col - 1) }}
            </a>
          </div>
        </div>

        <!-- Confirm Button (Bottom) -->
        <div class="confirm-section" v-if="isShow">
          <button
            type="button"
            @click="confirm()"
            :disabled="isDisabled"
            :class="['confirm-btn', { 'confirm-btn-disabled': isDisabled }]"
          >
            {{ buttonLabel }}
          </button>
        </div>

        <!-- Description -->
        <div class="description-card">
          <div class="description-text">{{ $t('huay_page.description') }}</div>
        </div>
      </div>

      <footerSection></footerSection>
    </div>
  </div>
</template>
<script>
import firebase, { database } from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import _ from 'lodash'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'
const axios = require('axios').default
require('vue2-animate/dist/vue2-animate.min.css')
// @ is an alias to /src
export default {
  name: 'Gift',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
        const _user = JSON.parse(user)
        this.$store.dispatch('user/setUser', _user).then(async()=>{
          const huay = (await firebase.database().ref('/huay').once('value')).val()
          const dateHuay = [];
          for(const x in huay){
            dateHuay.push(Number(huay[x]))
          }
          if(dateHuay.includes(Number(moment().tz("Asia/Bangkok").format('D')))){
              if(Number(moment().tz("Asia/Bangkok").format('H')+''+moment().tz("Asia/Bangkok").format('mm')) <= 1520){
                this.calculate();
                this.isShow = true;
              }else{
                 this.calculate();
              }
            }else{
              this.QTY = 0;
              this.countQTY = 0;
            }
        }).catch(err => { console.error(err) })
    } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
    }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  mounted () {
        this.buttonLabel = this.$t('huay_page.confirm_bet')
        this.animSplashScreen.play()
        setTimeout(() => {
            this.showLoading = false
            this.animSplashScreen.stop()
            // setTimeout(() => {
            //   this.canvas = document.getElementById('canvas')
            //   this.repaint(this.angle)
            // }, 500)
        }, 3500)
      //this.getGames()
  },
  data () {
    return {
      isShow: false,
      huays:[],
      rows:20,
      logoLeft: '',
      logoRight: '',
      angle: 0,
      gameKey: 'spin',
      showLoading: true,
      pictureUrl: '',
      code: '',
      games_web: [],
      search: '',
      loading: false,
      error: false,
      web: [],
      message: 'Invalid user name or password!',
      point: 0,
      favorites: [],
      animationInfinite: {
        classes: 'fadeIn',
        duration: 5000,
        iteration: 'infinite'
      },
      buttonLabel: '',
      permission: [],
      defaultOptions: null,
      defaultOptions2: null,
      defaultOptionsSplashScreen: null,
      openGiftData: false,
      canOpen: false,
      percentage: 0,
      loadingtext: '',
      credit: '',
      save: false,
      canvas: null,
      frame: null,
      wheels: null,
      sections: [],
      sectionspoint: [],
      colors: [],
      percent: [],
      isDisabled: false,
      QTY:'loading',
      countQTY:'loading',
    }
  },
  methods: {
    calculate(){
        firebase.firestore().collection('krungsri').where('date', '>=', moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 00:00:00').where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('userkey','==',this.user.key).get().then((snapshot)=>{
            let deposit = 0;
            snapshot.forEach((doc)=>{
                deposit += (Number(doc.data().qty.toString().replace(',','')));
            });
            const qty = Math.floor(deposit/200);
            this.QTY = (qty>10)?10:qty;
            if(qty){
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then((doc)=>{
                if(doc.exists){
                    if(doc.data().huays){
                        for(const x in doc.data().huays){
                            const xx = doc.data().huays[x];
                            this.huays[xx] = true;
                        }
                        this.countQTY = doc.data().huays.length;
                    }
                }else{
                    this.countQTY = 0;
                }
            });
            }
    });
    },
    selectNumber(num){
        if(typeof this.countQTY == 'number' && typeof this.QTY == 'number' && this.isShow){
            if(this.huays[num]){
                delete this.huays[num]
                this.countQTY--
            }else if(this.QTY > this.countQTY){
                this.huays[num] = true
                this.countQTY++
            }
            this.rows++;
            this.rows--;
        }
    },
    async confirm() {
        if(Object.keys(this.huays).length <= this.QTY && this.QTY > 0){
            this.buttonLabel = 'loading...';
            this.isDisabled = true;
            const huays = [];
            let lotto = '';
            for(const x in this.huays){
                if(this.huays[x]){
                    huays.push(x);
                    lotto += (lotto)?', '+x:x;
                } 
            }
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format('YYYY-MM-DD')).set({
                huays,
                userkey: this.user.key,
                updatetime: moment().tz("Asia/Bangkok").format('YYYY-MM-DD HH:mm:ss'),
                date: moment().tz("Asia/Bangkok").format('YYYY-MM-DD'),
                code:this.user.code,
            }).then(async ()=>{
                this.isDisabled = false;
                this.buttonLabel = this.$t('huay_page.confirm_bet');
                this.$confirm(
                    {
                        message: this.$t('huay_page.bet_success'),
                        button: {
                            yes: 'OK'
                        },
                        callback: confirm => {
                        if (confirm) {
                            
                            // this.getUserId()
                        }
                        }
                    }
                )
            });
        }else{
          alert(this.$t('huay_page.check_bet_rights'));
        }
    },
    renderNumber(row,i){
        const num = ((row-1)*5)+i;
        if(num.toString().length == 1){
            return '0'+num;
        }else{
            return num.toString();
        }
    },
    handleAnimationSplashScreen: function (anim) {
      this.animSplashScreen = anim
    },
    async getGames () {
      this.games_web = (await firebase.database().ref('/spin').once('value')).val()
    },
    checkCssBox (game) {
      if (!game.status) {
        return 'box-shadow: 0 0 12px 5px #cccccc;border: 2px solid #cccccc;'
      }
    },
    checkCss (game) {
      if (!this.permission || !this.permission[game.key]) {
        return 'filter: grayscale(100%);'
      }
      // const index = _.findIndex(this.favorites, function(o) { return o == code; });
      // if (index>-1) {
      //   return '';
      // } else {
      //   return 'filter: grayscale(100%);';
      // }
    },
    goto (type) {
      if (type === 'home') {
        // window.scrollTo({
        //   top: 0,
        //   left: 0,
        //   behavior: 'smooth'
        // });
        this.$router.push('/').catch(() => {})
      } else if (type === 'website') {
        window.location = this.web.link
        // this.gotoline()
      } else if (type === 'contact') {
        window.location = this.web.link_line
        // this.gotoline()
      }
    },
  }
}
</script>
<style scoped>
/* Loading Screen */
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #2b2727 0%, #1b1b1b 50%, #2b2727 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 40px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(247, 178, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(247, 178, 66, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  text-shadow:
    0 0 20px rgba(247, 178, 66, 0.5),
    0 0 40px rgba(247, 178, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

/* Quota Display */
.quota-display {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(247, 178, 66, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.3);
  border-radius: 25px;
  padding: 12px 25px;
  box-shadow:
    0 4px 15px rgba(0, 0, 0, 0.2),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.quota-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.quota-value {
  font-size: 20px;
  font-weight: 700;
  color: #f7b242;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.4);
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #f7b242, #ce840c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #ce840c, #f7b242);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #2b2727, #f7b242);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.lottery-content {
  padding: 30px 20px;
  max-width: 800px;
}

/* Info Card */
.info-card {
  background: rgba(247, 178, 66, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.3);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.info-icon {
  font-size: 28px;
  filter: drop-shadow(0 2px 8px rgba(247, 178, 66, 0.3));
}

.info-text {
  flex: 1;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

/* Confirm Section */
.confirm-section {
  text-align: center;
  margin-bottom: 30px;
}

.confirm-btn {
  background: linear-gradient(180deg, #91f27f 10%, #00b302);
  border: none;
  border-radius: 25px;
  padding: 14px 40px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: 'Kanit', sans-serif;
  box-shadow:
    0 4px 15px rgba(0, 179, 2, 0.3),
    0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 200px;
}

.confirm-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 20px rgba(0, 179, 2, 0.4),
    0 3px 8px rgba(0, 0, 0, 0.3);
  filter: brightness(1.1);
}

.confirm-btn-disabled,
.confirm-btn:disabled {
  background: linear-gradient(135deg, #666, #444);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

.confirm-btn-disabled:hover,
.confirm-btn:disabled:hover {
  transform: none;
  filter: none;
}

/* Numbers Grid */
.numbers-grid {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 25px 15px;
  margin-bottom: 30px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.number-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.number-row:last-child {
  margin-bottom: 0;
}

.number-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(247, 178, 66, 0.3);
  border-radius: 8px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.number-btn:hover {
  background: rgba(247, 178, 66, 0.15);
  border-color: rgba(247, 178, 66, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(247, 178, 66, 0.2);
}

.number-btn.active {
  background: linear-gradient(135deg, #f7b242, #ce840c);
  border-color: #f7b242;
  color: #fff;
  box-shadow:
    0 4px 15px rgba(247, 178, 66, 0.4),
    0 0 20px rgba(247, 178, 66, 0.3);
  transform: scale(1.05);
}

.number-btn.active:hover {
  transform: scale(1.08) translateY(-2px);
}

/* Description Card */
.description-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 25px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.description-text {
  text-align: center;
  font-size: 14px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

/* Tablet Responsive */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 35px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .quota-display {
    padding: 10px 20px;
  }

  .quota-label {
    font-size: 13px;
  }

  .quota-value {
    font-size: 18px;
  }

  .number-btn {
    width: 55px;
    height: 55px;
    font-size: 16px;
  }

  .numbers-grid {
    padding: 20px 10px;
  }

  .number-row {
    gap: 6px;
    margin-bottom: 6px;
  }
}

/* Mobile Responsive */
@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 30px;
  }

  .title-glow {
    font-size: 24px;
    margin-bottom: 15px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .lottery-content {
    padding: 20px 15px;
  }

  .quota-display {
    padding: 8px 16px;
  }

  .quota-label {
    font-size: 12px;
  }

  .quota-value {
    font-size: 16px;
  }

  .info-card {
    padding: 15px;
    gap: 12px;
  }

  .info-icon {
    font-size: 24px;
  }

  .info-text {
    font-size: 13px;
  }

  .number-btn {
    width: 50px;
    height: 50px;
    font-size: 15px;
  }

  .numbers-grid {
    padding: 15px 8px;
  }

  .number-row {
    gap: 5px;
    margin-bottom: 5px;
  }

  .confirm-btn {
    padding: 12px 30px;
    font-size: 14px;
    min-width: 180px;
  }

  .description-card {
    padding: 20px;
  }

  .description-text {
    font-size: 13px;
    line-height: 1.6;
  }
}
</style>
